/**------------- Where We Are constants -------------**/

/*  Title  */
export const WHERE_WE_ARE_TITLE = "Dove trovarci.";

/*  Working Hours  */
export const WHERE_WE_ARE_WORKING_HOURS_TITLE =
	"Orari d'apertura.";
export const WHERE_WE_ARE_WORKING_HOURS_DESCRIPTION =
	"- <strong>Lun-Ven</strong>: 08:30-13:00 / 15:00-19:00 <br>" +
	"- <strong>Sab</strong>: 08:30-13:00";

/*  Google Maps  */
export const WHERE_WE_ARE_GOOGLE_MAPS_LINK =
	"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.143408468909!2d16.4256612!3d40.8248136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13387b9989c61785%3A0xaa80de53bd394020!2sMM%20Eletricar%20Service%20di%20Vacca%20%26%20Scalese%20snc%20%E2%80%A2%20Meccatronica%20%E2%80%A2%20Elettrauto!5e0!3m2!1sit!2sit!4v1735907615314!5m2!1sit!2sit";
export const WHERE_WE_ARE_GOOGLE_MAPS_CONTAINER_CLASS_NAME =
	"google-maps-container";
export const WHERE_WE_ARE_GOOGLE_MAPS_IFRAME_CLASS_NAME =
	"google-maps-iframe";
export const WHERE_WE_ARE_GOOGLE_MAPS_IFRAME_TITLE =
	"google-maps";

/*  Fallback  */
export const WHERE_WE_ARE_GOOGLE_MAPS_UNAVAILABLE_DESCRIPTION =
	"Accetta i cookie di terze parti per visualizzare la nostra posizione sulla mappa.";

/*  Links  */
export const MAP_ICON_LINK = "/icons/map-icon.svg";
